/**
 * PersonalRecords Collection.  Defines a collection of PersonalRecord objects.
 */
import Backbone from 'backbone';

var UserBiometrics = Backbone.Model.extend({
    url: function() {
        return '/userprofile-service/userprofile/personal-information/' + this.getDisplayName();
    },

    backend: 'gcapi',

    initialize: function(args) {
        this.displayName = args.displayName;
    },

    getDisplayName: function() {
        return this.displayName;
    },

    getCountryCode: function() {
        let userInfo = this.get('userInfo');

        if (userInfo && userInfo.countryCode) {
            return userInfo.countryCode;
        }
    },

    getWeightInKg: function() {
        var biometricProfile = this.get('biometricProfile');

        if (biometricProfile && biometricProfile.weight) {
            return Math.round((biometricProfile.weight / 1000) * 10) / 10;
        }
    },

    updateWeightInKg: function(newWeight) {
        var biometricProfile = this.get('biometricProfile') || {};
        biometricProfile.weight = newWeight * 1000;
        this.set('biometricProfile', biometricProfile);
    },

    updateWeightInLbs: function(newWeight) {
        var biometricProfile = this.get('biometricProfile') || {};
        biometricProfile.weight = newWeight * 453.592;
        this.set('biometricProfile', biometricProfile);
    },

    updateWeightInSt: function(newWeight) {
        var biometricProfile = this.get('biometricProfile') || {};
        biometricProfile.weight = newWeight * 6350.293;
        this.set('biometricProfile', biometricProfile);
    }
});

export default UserBiometrics;
